// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"1a3b8a68","531":"1d7d15e8","986":"6161d27f"}[chunkId] + ".chunk.js";
};